// frontend/src/pages/AdminHome.js
import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import SystemStatusWidget from '../components/SystemStatusWidget';
import { Link } from 'react-router-dom';
import '../styles/adminHome.css';

const AdminHome = () => {
  const quickActions = [
    {
      title: '用户管理',
      description: '管理用户账户、权限和状态',
      icon: '👥',
      link: '/admin/users',
      color: 'primary'
    },
    {
      title: '设备管理',
      description: '监控设备状态、配置参数',
      icon: '🎮',
      link: '/admin/devices',
      color: 'success'
    },
    {
      title: '系统监控',
      description: '查看系统指标和性能监控',
      icon: '📈',
      link: '/admin/monitoring',
      color: 'info'
    },
    {
      title: '数据统计',
      description: '查看业务数据和统计报表',
      icon: '📊',
      link: '/admin/statistics',
      color: 'warning'
    },
    {
      title: '系统设置',
      description: '配置系统参数和功能开关',
      icon: '⚙️',
      link: '/admin/settings',
      color: 'secondary'
    },
    {
      title: '日志管理',
      description: '查看系统日志和操作记录',
      icon: '📝',
      link: '/admin/logs',
      color: 'dark'
    }
  ];

  return (
    <div className="admin-home">
      <div className="welcome-section">
        <h1>欢迎来到管理员后台</h1>
        <p className="text-muted">系统运行状况总览和快捷操作</p>
      </div>

      {/* 系统状态概览 */}
      <SystemStatusWidget />

      {/* 快捷操作 */}
      <Card className="quick-actions-card">
        <Card.Header>
          <h4>快捷操作</h4>
        </Card.Header>
        <Card.Body>
          <Row>
            {quickActions.map((action, index) => (
              <Col lg={4} md={6} sm={12} key={index} className="mb-3">
                <Link to={action.link} className="text-decoration-none">
                  <Card className={`quick-action-card border-${action.color}`}>
                    <Card.Body className="text-center">
                      <div className="action-icon">{action.icon}</div>
                      <h5 className="action-title">{action.title}</h5>
                      <p className="action-description text-muted">
                        {action.description}
                      </p>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>

      {/* 最近活动和提醒 */}
      <Row>
        <Col md={6}>
          <Card className="recent-activity-card">
            <Card.Header>
              <h5>最近活动</h5>
            </Card.Header>
            <Card.Body>
              <div className="activity-list">
                <div className="activity-item">
                  <div className="activity-icon bg-success">✓</div>
                  <div className="activity-content">
                    <div className="activity-title">系统监控功能已启用</div>
                    <div className="activity-time text-muted">刚刚</div>
                  </div>
                </div>
                <div className="activity-item">
                  <div className="activity-icon bg-info">📊</div>
                  <div className="activity-content">
                    <div className="activity-title">Prometheus 指标收集正常</div>
                    <div className="activity-time text-muted">5分钟前</div>
                  </div>
                </div>
                <div className="activity-item">
                  <div className="activity-icon bg-primary">🔧</div>
                  <div className="activity-content">
                    <div className="activity-title">监控中间件已集成</div>
                    <div className="activity-time text-muted">10分钟前</div>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="system-info-card">
            <Card.Header>
              <h5>系统信息</h5>
            </Card.Header>
            <Card.Body>
              <div className="info-list">
                <div className="info-item">
                  <span className="info-label">监控功能:</span>
                  <span className="info-value text-success">✓ 已启用</span>
                </div>
                <div className="info-item">
                  <span className="info-label">指标端点:</span>
                  <span className="info-value">
                    <code>/metrics</code>
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">健康检查:</span>
                  <span className="info-value">
                    <code>/health</code>
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">数据收集:</span>
                  <span className="info-value text-info">实时更新</span>
                </div>
                <div className="info-item">
                  <span className="info-label">部署说明:</span>
                  <span className="info-value">
                    <button type="button" className="btn btn-link p-0 text-decoration-none">
                      MONITORING_GUIDE.md
                    </button>
                  </span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AdminHome;
